export default __webpack_public_path__ + "static/media/web3BG.6cd37370.png";